import request from '@/utils/request';
export function splitObject(data) {
  return request.post('admin/split/object', data);
}
export function splitField(data) {
  return request.post('admin/split/field', data);
}
export function splitList(data) {
  return request.post('admin/split/list', data);
}
export const OPERATOR = ['=', '!=', '<', '<=', '>', '>=', 'contains', 'does not contain', 'is in list', 'is not in list'];
export const LOGICAL = ['and', 'or'];